import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { analyticsTrack } from '../../../analyticsUtils';
import googleSignIn from '../../../../assets/images/google-sign-up-logo.svg';
import msSignIn from '../../../../assets/images/ms-sign-up-logo.svg';
var redirectSocialLogin = function redirectSocialLogin(link, button, location) {
  analyticsTrack("Clicked sign up with ".concat(button), {
    location: location
  });
  window.open(link);
};
function SocialLoginForm(_ref) {
  var state = _ref.state,
    googleOmniauthUrl = _ref.googleOmniauthUrl,
    msOmniauthUrl = _ref.msOmniauthUrl,
    location = _ref.location;
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "sign-in-divider"
  }, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    className: "or-text"
  }, "or"), /*#__PURE__*/React.createElement("hr", null)), /*#__PURE__*/React.createElement("div", {
    className: "sign-in-provider"
  }, googleOmniauthUrl && /*#__PURE__*/React.createElement("a", {
    className: "google-sign-in mt-3",
    onClick: function onClick() {
      return redirectSocialLogin("".concat(googleOmniauthUrl, "?prompt=select_account&state=").concat(state), 'google', location);
    },
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("img", {
    src: googleSignIn,
    alt: "Sign up with Google"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sign-in-text"
  }, "Sign up with Google")), msOmniauthUrl && /*#__PURE__*/React.createElement("a", {
    className: "ms-sign-in mt-3",
    onClick: function onClick() {
      return redirectSocialLogin("".concat(msOmniauthUrl, "?state=").concat(state), 'microsoft', location);
    },
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("img", {
    src: msSignIn,
    alt: "Sign up with Microsoft"
  }), /*#__PURE__*/React.createElement("div", {
    className: "sign-in-text"
  }, "Sign up with Microsoft"))));
}
SocialLoginForm.propTypes = {
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
  state: PropTypes.string,
  location: PropTypes.string.isRequired
};
SocialLoginForm.defaultProps = {
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
  state: 'register_employer'
};
export default SocialLoginForm;